import React, { useEffect, useRef, useState } from 'react';
import ProjectCardMobile from '../components/ProjectCardMobile';
import {
  PhainoWrapper,
  NoiseWrapper,
  SiloportemWrapper,
  AnhydranWrapper,
  Phonemes2Wrapper,
  Phonemes1Wrapper,
  TransmutationWrapper,
  FlotsWrapper,
  TranscendanceWrapper,
  TinaWrapper,
  EveilWrapper
} from '../components/ProjectWrappers';
import NavigationMenu from '../components/NavigationMenu';
import LogoBlanc from '../components/LogoBlanc';
import './ProjectsGrid.css';

const PROJECTS_CONFIG = [
  // Pour modifier les images mobiles indépendamment, éditez uniquement mobileHoverConfig
  { wrapperClass: 'wrapper-phaino',
    hoverConfig:       { image1: '/media/MinPhainoOne.png',       image2: '/media/MinPhainoTwo.png',       displacementImage: '/media/1.png',  intensity: 0.2 },
    mobileHoverConfig: { image1: '/media/MinMobilePhainoOne.png',       image2: '/media/MinMobilePhainoTwo.png',      displacementImage: '/media/1.png',  intensity: 0.2 },
    textConfig: { title: 'PHAÍNŌ',       titleClass: 'title-phaino',       textClass: 'text-phaino',       texts: ['Installation immersive, spatialisation en octophonie,', 'performance, temps réel, composition interactive', '2026'] }, linkTo: '/phaino' },
  { wrapperClass: 'wrapper-noise',
    hoverConfig:       { image1: '/media/MinNoiseOne.png',         image2: '/media/MinNoiseTwo.png',         displacementImage: '/media/11.png', intensity: 0.5 },
    mobileHoverConfig: { image1: '/media/MinMobileNoiseOne.png',         image2 :'/media/MinMobileNoiseTwo.png',      displacementImage: '/media/11.png', intensity: 0.5 },
    textConfig: { title: 'NOISE',         titleClass: 'title-noise',        textClass: 'text-noise',        texts: ['rumeurs et anomalies', 'Installation, octophonie,', 'composition sonore contributive', '2026'] }, linkTo: '/noise' },
  { wrapperClass: 'wrapper-siloportem',
    hoverConfig:       { image1: '/media/MinSiloportemOne.png',    image2: '/media/MinSiloportemTwo.png',    displacementImage: '/media/10.png', intensity: 0.4 },
    mobileHoverConfig: { image1: '/media/MinMobileSiloportemOne.png',    image2: '/media/MinMobileSiloportemTwo.png',    displacementImage: '/media/10.png', intensity: 0.4 },
    textConfig: { title: 'SILOPORTEM',    titleClass: 'title-siloportem',   textClass: 'text-siloportem',   texts: ['Weaving the Heart Machine', 'Installation, spatialisation en octophonie, VJing', '2026'] }, linkTo: '/siloportem' },
  { wrapperClass: 'wrapper1',
    hoverConfig:       { image1: '/media/MinAnhydranOne.png',      image2: '/media/MinAnhydranTwo.png',      displacementImage: '/media/2.png',  intensity: 0.3 },
    mobileHoverConfig: { image1: '/media/MinMobileAnhydranTwo.png',    image2: '/media/MinMobileAnhydranOne.png',     displacementImage: '/media/2.png',  intensity: 0.3 },
    textConfig: { title: 'AN·HYDRA·N',   titleClass: 'title-anhydran',     textClass: 'text-anhydran',     texts: ['Installation immersive, spatialisation en octophonie,', 'performance, temps réel', '2023 - 2026'] }, linkTo: '/anhydran' },
  { wrapperClass: 'wrapper2',
    hoverConfig:       { image1: '/media/MinPhonemesTwoOne.png',   image2: '/media/MinPhonemesTwoTwo.png',   displacementImage: '/media/13.png', intensity: 0.2 },
    mobileHoverConfig: { image1: '/media/MinMobilePhonemeTwoOne.png',   image2: '/media/MinMobilePhonemeTwoTwo.png',  displacementImage: '/media/13.png', intensity: 0.2 },
    textConfig: { title: 'PHONÈMES #2',  titleClass: 'title-phonemes2',    textClass: 'text-phonemes2',    texts: ['Installation immersive, spatialisation en 5.1', '2021 - 2022'] }, linkTo: '/phonemes2' },
  { wrapperClass: 'wrapper3',
    hoverConfig:       { image1: '/media/MinPhonemesOneTwo.png',   image2: '/media/MinPhonemesOneOne.png',   displacementImage: '/media/1.png',  intensity: 1.8 },
    mobileHoverConfig: { image1: '/media/MinMobilePhonemeTwo.png',   image2: '/media/MinMobilePhonemeOne.png',   displacementImage: '/media/1.png',  intensity: 1.8 },
    textConfig: { title: 'PHONÈMES',     titleClass: 'title-phonemes1',    textClass: 'text-phonemes1',    texts: ['Installation immersive, spatialisation en octophonie', '2020 - 2022'] }, linkTo: '/phonemes1' },
  { wrapperClass: 'wrapper4',
    hoverConfig:       { image1: '/media/MinTransmutationOne.png', image2: '/media/MinTransmutationTwo.png', displacementImage: '/media/10.png', intensity: 1   },
    mobileHoverConfig: { image1: '/media/MinMobileTransmutationOne.png', image2: '/media/MinMobileTransmutationTwo.png', displacementImage: '/media/10.png', intensity: 1   },
    textConfig: { title: 'TRANSMUTATION',titleClass: 'title-transmutation', textClass: 'text-transmutation', texts: ['Installation, quadriphonie', '2019 - 2023'] }, linkTo: '/transmutation' },
  { wrapperClass: 'wrapper5',
    hoverConfig:       { image1: '/media/MinFlotsOne.png',         image2: '/media/MinFlotsTwo.png',         displacementImage: '/media/11.png', intensity: 0.8 },
    mobileHoverConfig: { image1: '/media/MinMobileFlotsOne.png',         image2: '/media/MinMobileFlotsTwo.png',        displacementImage: '/media/11.png', intensity: 0.8 },
    textConfig: { title: 'FLOTS',        titleClass: 'title-flots',        textClass: 'text-flots',        texts: ['Installation', '2019 - 2021'] }, linkTo: '/flots' },
  { wrapperClass: 'wrapper6',
    hoverConfig:       { image1: '/media/MinTranscendanceOne.png', image2: '/media/MinTranscendanceTwo.png', displacementImage: '/media/10.png', intensity: 0.8 },
    mobileHoverConfig: { image1: '/media/MinMobileTranscendanceOne.png', image2: '/media/MinMobileTranscendanceTwo.png', displacementImage: '/media/10.png', intensity: 0.8 },
    textConfig: { title: 'TRANSCENDANCE',titleClass: 'title-transcendance', textClass: 'text-transcendance', texts: ['Modélisation', '2019 - 2022'] }, linkTo: '/transcendance' },
  { wrapperClass: 'wrapper7',
    hoverConfig:       { image1: '/media/MinTINAOne.png',          image2: '/media/MinTINATwo.png',          displacementImage: '/media/1.png',  intensity: 2   },
    mobileHoverConfig: { image1: '/media/MinMobileTinaOne.png',         image2: '/media/MinMobileTinaTwo.png',          displacementImage: '/media/1.png',  intensity: 2   },
    textConfig: { title: 'T.I.N.A.',     titleClass: 'title-tina',         textClass: 'text-tina',         texts: ['Installation, performance', '2018 - 2019'] }, linkTo: '/tina' },
  { wrapperClass: 'wrapper8',
    hoverConfig:       { image1: '/media/MinEveilOne.png',         image2: '/media/MinEveilTwo.png',         displacementImage: '/media/2.png',  intensity: 0.35},
    mobileHoverConfig: { image1: '/media/MinMobileEveilOne.png',       image2: '/media/MinMobileEveilTwo.png',        displacementImage: '/media/2.png',  intensity: 0.35},
    textConfig: { title: 'ÉVEIL',        titleClass: 'title-eveil',        textClass: 'text-eveil',        texts: ['Captation, performance', '2018 - 2022'] }, linkTo: '/eveil' },
];

const ProjectsGrid = () => {
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Effet pour ajouter le défilement horizontal — se réexécute quand isMobile change
  useEffect(() => {
    if (isMobile) return; // pas de scroll horizontal en responsive
    const container = containerRef.current;
    if (!container) return;

    const handleWheel = (e) => {
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    };

    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, [isMobile]);

  const scrollBy = (direction) => {
    const container = containerRef.current;
    if (!container) return;
    container.scrollBy({ left: direction * window.innerWidth * 0.7, behavior: 'smooth' });
  };

  return (
    <>
      <NavigationMenu />
      <LogoBlanc />
      <h1 className="projects-page-title">Projets</h1>

      {isMobile ? (
        /* ── Layout mobile : grille verticale ── */
        <div className="pgm-container">
          <div className="pgm-grid">
            {PROJECTS_CONFIG.map((p) => (
              <ProjectCardMobile
                key={p.wrapperClass}
                wrapperClass={p.wrapperClass}
                hoverConfig={p.hoverConfig}
                mobileHoverConfig={p.mobileHoverConfig}
                textConfig={p.textConfig}
                linkTo={p.linkTo}
              />
            ))}
          </div>
        </div>
      ) : (
        /* ── Layout desktop : grille horizontale ── */
        <div className="projects-container" ref={containerRef}>
          <div className="projects-grid">
            <PhainoWrapper />
            <NoiseWrapper />
            <SiloportemWrapper />
            <AnhydranWrapper />
            <Phonemes2Wrapper />
            <Phonemes1Wrapper />
            <TransmutationWrapper />
            <FlotsWrapper />
            <TranscendanceWrapper />
            <TinaWrapper />
            <EveilWrapper />
          </div>
        </div>
      )}

      {/* Boutons navigation desktop — bas au centre, toujours visibles */}
      {!isMobile && (
        <div style={{
          position: 'fixed',
          bottom: '2.5rem',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '1rem',
          zIndex: 500,
          pointerEvents: 'auto'
        }}>
          <button onClick={() => scrollBy(-1)} style={{
            background: 'rgba(7,3,26,0.6)',
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: '4px',
            color: 'rgba(255,255,255,0.7)',
            fontSize: '2.2rem',
            width: '4rem',
            height: '3rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)',
            transition: 'background 0.3s ease'
          }}
          onMouseEnter={e => e.currentTarget.style.background='rgba(40,212,198,0.2)'}
          onMouseLeave={e => e.currentTarget.style.background='rgba(7,3,26,0.6)'}
          >‹</button>
          <button onClick={() => scrollBy(1)} style={{
            background: 'rgba(7,3,26,0.6)',
            border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: '4px',
            color: 'rgba(255,255,255,0.7)',
            fontSize: '2.2rem',
            width: '4rem',
            height: '3rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(4px)',
            transition: 'background 0.3s ease'
          }}
          onMouseEnter={e => e.currentTarget.style.background='rgba(40,212,198,0.2)'}
          onMouseLeave={e => e.currentTarget.style.background='rgba(7,3,26,0.6)'}
          >›</button>
        </div>
      )}
    </>
  );
};

export default ProjectsGrid;